import { CalendarDays, ChevronDown, Download } from "lucide-react";

export default function ForexHeader() {
    return (
        <div className="w-full flex items-center justify-end gap-x-3">
            <button className="bg-card w-fit p-2 rounded-md text-white flex items-center gap-x-2">
                <p className="text-white text-sm">All Services</p>
                <ChevronDown size={16} />
            </button>

            <button className="bg-card w-fit p-2 rounded-md text-white flex items-center gap-x-2">
                <CalendarDays size={16} />
                <p className="text-white text-sm">6 Months</p>
                <ChevronDown size={16} />
            </button>

            <button className="bg-card w-fit p-2 rounded-md text-white flex items-center gap-x-2">
                <Download size={16} />
                <p className="text-white text-sm">Download Report</p>
            </button>
        </div>
    );
}